// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { enums } from "../../../utils/enums";

export const CommunityGuidelinePageSuperAppStyles = (config: DesignSystem) => ({
    communityGuidelinePageSuperAppContainer: {
        height: "calc(100vh - 20px)",
        "max-height": "calc(100vh - 20px)",
        "box-sizing": "border-box",
        "overflow-y": "scroll"
    }
});